import Vue from 'vue';
import store from './../../store';
import clientTransformer from '../../transformers/client';

const success = ({ data }, resolve) => {
  const clients = clientTransformer.fetchCollection(data.data);
  store.dispatch('fetchAllClientOptions', clients);
  resolve(clients);
};

const failed = (error, reject) => reject(error);


export default (params = '') => (
  new Promise((resolve, reject) => {
    Vue.$http.get(`/clients?basic_fields=1${params}`)
      .then((response) => {
        success(response, resolve);
      })
      .catch((error) => {
        failed(error, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/client/allOptions.js